import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['trade-countdown-box', _ctx.isDisabled ? 'disabled' : '']),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.handleClick && _ctx.handleClick(...args), ["self"]))
  }, _toDisplayString(_ctx.btnText), 3);
}